import ClientDashboardPage from "./ClientDashboardPage";

export default ClientDashboardPage;
